<template>
	<div>
		<app-head :title="$t('title.homepage')" />
		<v-container fluid class="pa-0">
			<section>
				<app-menu
					:customer="customer"
					:customer_image="$page.props.auth.customer_image"
					class="container--box"
				></app-menu>
			</section>
			<section>
				<app-place-order
					class="container--box"
					:socials="socials"
				></app-place-order>
			</section>
			<section>
				<app-service
					:background="background"
					:app_store="app_store"
					:play_store="play_store"
					:socials="socials"
				></app-service>
			</section>
		</v-container>
	</div>
</template>

<script>
export default {
	props: ["socials"],
	data() {
		return {
			image_placeholder: this.$page.props.assets.image_placeholder,
			background: this.$page.props.assets.background,
			app_store: this.$page.props.assets.app_store,
			play_store: this.$page.props.assets.play_store,
		};
	},
	computed: {
		customer() {
			return this.$page.props.auth.customer;
		},
	},
};
</script>